import logger from '~/utils/logger/logger';

export const decodeBase64Utf8String = (encodedBase64String: string): string | undefined => {
  try {
    const binaryString = atob(encodedBase64String);
    const utf8Bytes = new Uint8Array(binaryString.length);
    for (let i = 0; i < binaryString.length; i++) {
      utf8Bytes[i] = binaryString.charCodeAt(i);
    }
    return new TextDecoder().decode(utf8Bytes);
  } catch (error) {
    logger.error('Error decoding Base64:', error);
  }
};
export const decodeAndParseBase64Utf8String = (encodedBase64String: string) => {
  let decodedData = {};
  const decodedDataString = decodeBase64Utf8String(encodedBase64String);
  if (decodedDataString) {
    try {
      decodedData = JSON.parse(decodedDataString);
    } catch (e) {
      logger.warn('Failed to parse decoded data', e);
    }
  }
  return decodedData;
};
